// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__MMj71","log":"ModalInventoryLogs_log__hS7Ym","date":"ModalInventoryLogs_date__2FK2z","userName":"ModalInventoryLogs_userName__vsF5n"};